import { ApiErrorResponse } from '@/types/api'
import { createContext } from 'react'

export type WorkspaceContextType = {
  workspaceId: string | null
  setWorkspaceId: (id: string) => void
  clearWorkspaceId: () => void
  isLoading: boolean
  error: ApiErrorResponse | null
}

export const WorkspaceContext = createContext<WorkspaceContextType | null>(null)
